import React, { Component } from 'react';
import { translate } from 'react-i18next';

import LogoGobiernoWhite from 'static/img/gobierno_white.png';

import './Footer.css';

class Footer extends Component {

  render() {
    return (
      <footer>
        <div>
          © {new Date().getFullYear()} Instituto Geográfico de Aragón. Todos los derechos reservados.<br/> Ed. Pignatelli. Paseo María Agustín, 36 puerta 14 planta 3, 50071 Zaragoza. Tel. +34 976 71 56 05
        </div>
        <div>
          <a href="https://icearagon.aragon.es/accesibilidad.jsp" target="_blank" rel="noreferrer noopener">ACCESIBILIDAD</a>
          <a href="https://icearagon.aragon.es/portal/politica-privacidad.jsp" target="_blank" rel="noreferrer noopener">AVISO LEGAL. PROTECCIÓN DE DATOS</a>
          <a href="https://icearagon.aragon.es/mapa-web.jsp" target="_blank" rel="noreferrer noopener">MAPA WEB</a>
          <a href="mailto:igear@aragon.es" target="_blank" rel="noreferrer noopener">CONTACTO</a>
        </div>
        <div>
          <a href="https://www.aragon.es/" target="_blank" rel="noreferrer noopener">
            <img src={LogoGobiernoWhite} alt='Logo del gobierno en blanco' />
          </a>
        </div>
      </footer>
    );
  }
}

export default translate()(Footer);
